import { Heart, CheckCheck } from "lucide-react";
import { useState, useEffect } from "react";
import {
  recordHotspotIntent,
  checkHotspotIntent,
} from "../../../apis/recordHotspotIntent";

const HotspotIntentMarker = ({ hotspotId }) => {
  const [isMarked, setIsMarked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchIntentStatus = async () => {
      const result = await checkHotspotIntent(hotspotId);
      if (result.success) {
        setIsMarked(result.data?.data?.has_marked_intent ?? false);
      }
      setIsLoading(false);
    };

    fetchIntentStatus();
  }, [hotspotId]);

  const handleMarkInterest = async () => {
    if (isLoading || isMarked) return;

    setIsLoading(true);
    const result = await recordHotspotIntent(hotspotId);

    if (result.success) {
      setIsMarked(true);
    }
    setIsLoading(false);
  };

  if (isMarked) {
    return (
      <div className="hotspot-intent-marker marked">
        <CheckCheck size={16} className="icon-check" />
        <span>Sweet! We're tuning into your taste.</span>
      </div>
    );
  }

  return (
    <div className="hotspot-intent-marker">
      <span className="intent-text">Want invites from similar hotspots?</span>
      <button
        className="intent-button"
        onClick={handleMarkInterest}
        disabled={isLoading}
      >
        <Heart size={16} />
        <span>{isLoading ? "..." : "Yes"}</span>
      </button>
    </div>
  );
};

export default HotspotIntentMarker;
